// DialogTitle.tsx (Atom)
import React from "react"
import { cn } from '@/utils/index'

interface DialogTitleProps {
  className?: string
  children: React.ReactNode
}

export function DialogTitle({ className, children }: DialogTitleProps) {
  return <h2 className={cn("text-lg font-semibold dark:text-neutral-300", className)}>{children}</h2>
}
